//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {querydevicelocationhistory, sendcommandmessage, querydevicelocation} from '../../api/device'

export default {
  name: 'mapCat',
  data () {
    return {
      deviceData: '',
      selectTitle: 0,
      mapObj: {
        deviceInfo: '',
        // lngLat: [113.883638, 22.5911971],
        lngLatArr: [],
        isMarker: true
      },
      showYearTime: false,
      yTime: '',
      yTimeInfo: new Date(),
      manDate: new Date(2022, 12, 12),
      isLine: false,
      num: 0,
      intervalId: null
      // isM: false
    }
  },
  created () {
    this.golobleObject.getStartMap = this.getShowMarker
    this.golobleObject.changeDevicePage = this.changeMatt
    this.deviceData = this.$store.getters.get_child_obj
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    let day = new Date().format('yyyy-MM-dd')
    this.yTime = day
    this.mapObj.deviceInfo = this.deviceData
    this.getHistoryLocation()
    document.getElementsByTagName('title')[0].innerText = '定位详情'
  },
  mounted () {},
  beforeDestroy () {
    document.getElementsByTagName('title')[0].innerText = '智慧安防'
  },
  methods: {
    getLocationDevice1 () {
      let data = {
        did: this.deviceData.id,
        imei: this.deviceData.deviceid
      }
      querydevicelocation(data).then(res => {
        let obj = res.data
        this.mapObj.deviceInfo.ptype = parseFloat(obj.ptype)
        this.mapObj.deviceInfo.lng = parseFloat(obj.lng)
        this.mapObj.deviceInfo.lat = parseFloat(obj.lat)
        this.mapObj.deviceInfo.last_online = obj.ptime
        window.frames['mainIframe'].window.startData(this.mapObj)
      })
    },
    onConfirm (time) {
      // console.log(time)
      this.yTime = time.format('yyyy-MM-dd')
      this.isLine = true
      this.getHistoryLocation()
      this.showYearTime = false
    },
    getHistoryLocation () {
      let data = {
        imei: this.deviceData.deviceid,
        did: this.deviceData.id,
        from: this.yTime + ' 00:00:00',
        to: this.yTime + ' 23:59:59'
      }
      querydevicelocationhistory(data).then(res => {
        // console.log(123, res.data)
        if (res.data && res.data.length > 0) {
          this.mapObj.lngLatArr = res.data
        } else {
          this.mapObj.lngLatArr = []
        }
        if (this.isLine) {
          window.frames['mainIframe'].window.startData(this.mapObj)
        }
        this.isLine = false
      }).catch(() => {})
    },
    openTitleSelect (index) {
      this.selectTitle = index
      if (index === 1) {
        this.mapObj.isMarker = false
      } else {
        this.mapObj.isMarker = true
      }
      if (this.intervalId) {
        clearInterval(this.intervalId)
        this.intervalId = null
        this.num = 0
      }
      window.frames['mainIframe'].window.startData(this.mapObj)
    },
    getShowMarker (obj) {
      if (obj.type === 'start') {
        this.getLocationDevice1()
        // window.frames['mainIframe'].window.startData(this.mapObj)
      } else if (obj.type === 'update') {
        this.getDeviceChange()
      }
    },
    // 刷新位置
    getDeviceChange () {
      // 定位模式 按次定位 发送指令
      let data = {
        imei: this.deviceData.deviceid,
        did: this.deviceData.id
      }
      if (this.deviceData.dtype === 901) {
        data.method = 'requirelocation'
        data.command1 = '1'
        data.command2 = '2'
        data.command3 = '1'
        data.command4 = '2'
      } else if (this.deviceData.dtype === 301 || this.deviceData.dtype === 350 || this.deviceData.dtype === 310 || this.deviceData.dtype === 311 || this.deviceData.dtype === 312 ||
        this.deviceData.dtype === 330 || this.deviceData.dtype === 332) {
        data.method = 'requirelocation310'
        data.command1 = '1|1|1|5'
        data.reserved2 = this.deviceData.dtype + ''
      }
      sendcommandmessage(data).then(res => {
        if (this.deviceData.dtype !== 301) {
          this.$toast('成功发送指令')
        }
        this.getImeiData()
      })
    },
    getImeiData () {
      this.num = 0
      let vm = this
      vm.getLocationDevice()
      // console.log(this.num)
      this.intervalId = setInterval(() => {
        vm.getLocationDevice()
      }, 5000)
    },
    getLocationDevice () {
      console.log(this.num)
      this.num += 1
      let data = {
        did: this.deviceData.id,
        imei: this.deviceData.deviceid
      }
      if (this.num === 5) {
        clearInterval(this.intervalId)
        this.intervalId = null
        this.num = 0
      }
      querydevicelocation(data).then(res => {
        let obj = res.data
        if (parseFloat(this.mapObj.deviceInfo.lng) !== parseFloat(obj.lng) || parseFloat(this.mapObj.deviceInfo.lat) !== parseFloat(obj.lat)) {
          this.$toast('成功刷新位置')
          clearInterval(this.intervalId)
          this.intervalId = null
          this.num = 0
          this.mapObj.deviceInfo.ptype = parseFloat(obj.ptype)
          this.mapObj.deviceInfo.lng = parseFloat(obj.lng)
          this.mapObj.deviceInfo.lat = parseFloat(obj.lat)
          this.mapObj.deviceInfo.last_online = obj.ptime
          window.frames['mainIframe'].window.startData(this.mapObj)
        }
      }).catch(() => {
        clearInterval(this.intervalId)
        this.intervalId = null
        this.num = 0
      })
    },
    changeMatt (obj) {
      if (obj.imei === this.mapObj.deviceInfo.deviceid) {
        this.mapObj.deviceInfo.ptype = parseFloat(obj.ptype)
        this.mapObj.deviceInfo.lng = parseFloat(obj.x)
        this.mapObj.deviceInfo.lat = parseFloat(obj.y)
        this.mapObj.deviceInfo.last_online = obj.ptime
        window.frames['mainIframe'].window.startData(this.mapObj)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/device/mapCat.vue